import createIcon from '../../createIcon';

/**
 * @component @name TextIncrease
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMC45OTUxMTcgMTlIMy40MTUxMkw0LjY4NTEyIDE1LjQySDEwLjMzNTFMMTEuNTk1MSAxOUgxNC4wMTUxTDguNzU1MTIgNUg2LjI1NTEyTDAuOTk1MTE3IDE5Wk01LjQxNTEyIDEzLjM5TDcuNDQ1MTIgNy42SDcuNTY1MTJMOS41OTUxMiAxMy4zOUg1LjQxNTEyWk0yMC4wMDUxIDExSDIzLjAwNTFWMTNIMjAuMDA1MVYxNkgxOC4wMDUxVjEzSDE1LjAwNTFWMTFIMTguMDA1MVY4SDIwLjAwNTFWMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextIncrease = createIcon('TextIncrease', [
  [
    'path',
    {
      d: 'M0.995117 19H3.41512L4.68512 15.42H10.3351L11.5951 19H14.0151L8.75512 5H6.25512L0.995117 19ZM5.41512 13.39L7.44512 7.6H7.56512L9.59512 13.39H5.41512ZM20.0051 11H23.0051V13H20.0051V16H18.0051V13H15.0051V11H18.0051V8H20.0051V11Z',
      key: 'w52fpx',
    },
  ],
]);

export default TextIncrease;
